const matchNotificationPeriods = ["immediately", "whenEnough", "never"].reduce(
  (acc, val) => {
    acc[val.toUpperCase()] = val;
    return acc;
  },
  {}
);

const leadNotificationPeriods = ["immediately", "onceADay", "never"].reduce(
  (acc, val) => {
    acc[val.toUpperCase()] = val;
    return acc;
  },
  {}
);

const notificationsSchema = {
  matches: {
    type: String,
    enum: Object.values(matchNotificationPeriods),
    default: matchNotificationPeriods.IMMEDIATELY,
  },
  leads: {
    type: String,
    enum: Object.values(leadNotificationPeriods),
    default: leadNotificationPeriods.ONCEADAY,
  },
};
const settings = {
  matches: {
    emailMatchesAfterHoursFromThread: 48,
    emailMatchesOnceNCollected: 4,
  },
};
module.exports = {
  notificationsSchema,
  matchNotificationPeriods,
  leadNotificationPeriods,
  matchLeadSettings: settings,
};
